<div>
  <a *ngIf="params?.onClickCallback; else plainText" xpo-regular-link (click)="openDetail()">{{
    displayValue ? displayValue : params.value
  }}</a>
  <ng-template #plainText>{{ displayValue ? displayValue : params.value }}</ng-template>
</div>
